module.exports = __webpack_public_path__ + "img/type-filling-active.118dfe80.svg";